


















































import { StreamRepository } from '@/core/api/streams'
import Vue from 'vue'

export default Vue.extend({
  components: {},
  data: () => ({
    loading: false,
    items: [],
    itemsCount: null,
    page: 1,
    pageCount: 1,
    headers: [
      {
        text: 'Название',
        value: 'name',
      },
      {
        text: 'Изменен',
        value: 'modified',
      },
      {
        text: 'URL',
        value: 'url',
      },
      {
        text: 'Рекордер',
        value: 'recorder',
      },
    ],
  }),
  watch: {
    page(newPage) {
      this.$router.replace({ query: { ...this.$route.query, page: newPage } })
    },
  },
  mounted() {
    this.page = parseInt(this.$route.query.page as string) || 1
    this.fetch()
  },
  methods: {
    fetch() {
      this.loading = true
      new StreamRepository()
        .$getPage(this.page)
        .then(({ results, count, pages }) => {
          this.items = results
          this.itemsCount = count
          this.pageCount = pages
        })
        .catch(() => {
          this.$toastError.fire()
        })
        .finally(() => {
          this.loading = false
        })
    },
    onItemClick(item) {
      this.$router.push({ name: 'StreamEdit', params: { id: item.id } })
    },
    onCreateItemClick() {
      this.$router.push({ name: 'StreamCreate' })
    },
    onPageChange() {
      this.fetch()
    },
  },
})
